import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import { Button, Stack, Typography } from '@mui/material';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
// import AppRegistrationOutlinedIcon from '@mui/icons-material/AppRegistrationOutlined';
import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';
// import { deleteEventRegister } from '../../helpers/eventRegister';

export const CardEventBlue = ({ event, myEvents, setReloadData }) => {

    const { t } = useTranslation('global');
    // const navigate = useNavigate();

    const onSeeMoreClick = () => {
        window.open(event.url, '_blank')
    }

    // const onDeleteRegister = async () => {
    //     await deleteEventRegister(event, 'Se ha desapuntado del evento', 'Ha habido un error, intentelo nuevamente o contacte con faraday', 'Cancelar', 'Confirmar', 'Confirma que no asistirá al evento: ')
    //     setReloadData(reloadData => !reloadData)
    // }

    let size = event.name.length > 55 ? '16px' : '22px'
    if (event.name.length > 110 ) size = '14px'
    return (
        <Box sx={{ width: 300 }}>
            <Card variant="outlined" sx={{ backgroundColor: 'primary.main', height: '185px' }}>
                <CardContent>
                    <Stack direction='row' justifyContent='space-between'>
                        <Typography sx={{ fontSize: 14 }} color="info.main" gutterBottom>
                            {event.eventDate}
                        </Typography>
                        {/* {
                            myEvents.dataNo.includes(event.id) &&
                            <Typography sx={{ fontSize: 14 }} color="error.main" gutterBottom>
                                {t('addevent.notGoing')}
                            </Typography>
                        }
                        {
                            myEvents.dataConfirm.includes(event.id) &&
                            <Typography sx={{ fontSize: 14 }} color="success.main" gutterBottom>
                                {t('addevent.registeredCard')}
                            </Typography>
                        } */}
                    </Stack>
                    <Typography variant="h6" component="div" color='secondary' sx={{height:'72px', overflow: 'auto', fontSize: size}}>
                        {event.name}
                    </Typography>
                </CardContent>
                <CardActions >
                    <Button
                        color='info'
                        variant='outlined'
                        size="small"
                        fullWidth
                        startIcon={<RemoveRedEyeOutlinedIcon />}
                        onClick={onSeeMoreClick}
                    >
                        {t('addevent.buttonUrl')}
                    </Button>
                    {/* {
                        myEvents.dataConfirm.includes(event.id) &&

                        <Button
                            color='error'
                            variant='outlined'
                            size="small"
                            sx={{ width: '49%' }}
                            startIcon={<AppRegistrationOutlinedIcon />}
                            onClick={onDeleteRegister}
                        >
                            {t('addevent.notAttend')}
                        </Button>
                    }
                    {
                        myEvents.dataNo.includes(event.id) &&
                        <Button
                            color='success'
                            variant='outlined'
                            size="small"
                            sx={{ width: '49%' }}
                            startIcon={<AppRegistrationOutlinedIcon />}
                            onClick={() => navigate(`/confirmEvent?url=${event.url}&event=${event.name}&amount=${event.id}&edit=true`)}
                        >
                            {t('addevent.edit')}
                        </Button>
                    }
                    {
                        (!myEvents.dataNo.includes(event.id) && !myEvents.dataConfirm.includes(event.id)) &&
                        <Button
                            color='success'
                            variant='outlined'
                            size="small"
                            sx={{ width: '49%' }}
                            startIcon={<AppRegistrationOutlinedIcon />}
                            onClick={() => navigate(`/confirmEvent?url=${event.url}&event=${event.name}&amount=${event.id}&edit=false`)}
                        >
                            {t('addevent.buttonSeeMore')}
                        </Button>
                    } */}

                </CardActions>
            </Card>
        </Box>
    );
}